let BASE_URL = process.env.VUE_APP_BASE_URL || '';

if (process.env.NODE_ENV === 'development') {
  // BASE_URL = 'http://wahuo.tpddns.cn:8001/clipper/'
  BASE_URL = 'http://192.168.0.120:8001/clipper/';
  // BASE_URL = 'http://192.168.0.106:18080/clipper/';
} else if (process.env.NODE_ENV === 'production') {
  // BASE_URL = 'https://data.d2read.com/clipper/';
  // BASE_URL = 'http://wahuo.tpddns.cn:8000/clipper/';
  // BASE_URL = 'http://clip.piaoao.com:8000/clipper/'
}

export { BASE_URL };
